// extracted by mini-css-extract-plugin
export default {"block":"ConfirmLocation_block__7s6P4","cancel":"ConfirmLocation_cancel__i9pxW","title":"ConfirmLocation_title__JGTVU","btnConfirm":"ConfirmLocation_btnConfirm__qUeV4"};